export const ETrackerActions = {
  VIEW: 'view',
  CLICK: 'click',
  SCROLL: 'scroll',
  SUCCESS: 'success',
} as const;

export type TTrackerActions = (typeof ETrackerActions)[keyof typeof ETrackerActions];
